// updatePWA.js
export function checkForUpdates() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then(registration => {
      if (registration) {
        // Força o SW a buscar nova versão
        registration.update();

        // Se o SW ativar (nova versão pronta), recarrega
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload();
        });
      }
    });
  }
}
